import { render, staticRenderFns } from "./edit_remark_recommendation_modal.vue?vue&type=template&id=43d0974a&"
import script from "./edit_remark_recommendation_modal.vue?vue&type=script&lang=js&"
export * from "./edit_remark_recommendation_modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports